import { ApolloError, useQuery } from '@apollo/client'
import { CompaniesAndBusinessUnitsByEmployeeQuery, CompaniesAndBusinessUnitsByEmployeeQueryVariables, Country } from '../../../types'
import { COMPANY_AND_BU } from '../Queries'

export default (
  employeeId: number,
  country: Country,
): { data: CompaniesAndBusinessUnitsByEmployeeQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    id: employeeId,
    country,
  }

  const { data, error, loading } = useQuery<CompaniesAndBusinessUnitsByEmployeeQuery, CompaniesAndBusinessUnitsByEmployeeQueryVariables>(
    COMPANY_AND_BU,
    {
      variables: variables,
      fetchPolicy: 'network-only',
    },
  )

  return { data, error, loading }
}
